﻿define('instrumentation/log-level', {
    INFO: {
        name: 'Info',
        value: 0
    },
    DEBUG: {
        name: 'Debug',
        value: 1
    },
    VERBOSE: {
        name: 'Verbose',
        value: 2
    },
});
